<div class="pageheader">
    <div class="page-title">
        <h1>Configuration keys</h1>
        <div class="btn-group">
            <button class="btn btn-link" (click)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
            <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'Variant versions log'">
                <app-change-log-link-entity type="ConfigurationKey"></app-change-log-link-entity>
            </app-change-log-link>
        </div>
    </div>
</div>

<div class="container container-fixed">
    <div class="row">
        <div class="col-sm-12">

            <dx-data-grid biz-grid [selection]='{ mode: "none" }' [dataSource]='configKeys' [bizSetGroupPanel]="false"
                [bizSetColumnChooser]="false" [bizSetAllowColumnReordering]="false" [bizSetPager]="false"
                (onToolbarPreparing)="onToolbarPreparing($event)" (onRowRemoving)="onRowRemoving($event)" (rowDoubleClick)="editConfigKey($event)">

                <dxo-editing mode="popup" [allowAdding]="allowAdding" [allowDeleting]="allowDeleting"></dxo-editing>

                <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

                <dxo-group-panel [visible]="false"></dxo-group-panel>

                <dxi-column dataField="KeyName" caption="Key Name" dataType="string" width="50%" sortOrder="asc">
                    <dxi-validation-rule type="required"></dxi-validation-rule>
                </dxi-column>

                <dxi-column dataField="ConfigurationKeyUsagesId" caption="Usage" width="50%">
                    <dxo-lookup [dataSource]="usages" valueExpr="KeyUsageId" displayExpr="KeyUsageName">
                    </dxo-lookup>
                    <dxo-header-filter [dataSource]="bizGridFiltervalues.geConfigurationKeyUsageFilterData(bizGridFiltervalues.getPropertyValues(this.configKeys, 'ConfigurationKeyUsagesId'), usages)"/>  
                </dxi-column>

                <dxi-column biz-grid-user dataField="CreatedBy" caption="Created By" [visible]="true"><dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(this.configKeys, 'CreatedBy'))"></dxo-header-filter></dxi-column>
                <dxi-column biz-grid-date dataField="CreatedDate" caption="Created Date" [visible]="true" format="dateTime"></dxi-column>
                <dxi-column biz-grid-user dataField="UpdatedBy" caption="Modified By" [visible]="true"><dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(this.configKeys, 'UpdatedBy'))"></dxo-header-filter>   </dxi-column>
                <dxi-column biz-grid-date dataField="UpdatedDate" caption="Modified Date" [visible]="true" format="dateTime"></dxi-column>

                <dxi-column type="buttons">
                    <dxi-button name="edit"
                                template="editTemplate"
                                [visible]="allowEditing">
                    </dxi-button>
                    <dxi-button name="delete"></dxi-button>
                    <dxi-button text="Show Log"
                                template="logTemplate"
                                [visible]="allowShowLog">
                    </dxi-button>
                </dxi-column>
            
                <ng-container *dxTemplate="let cell of 'logTemplate'">
                    <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'Log for ' + cell.data.KeyName" [showIcon]="false" classNames="dx-link">
                        <app-change-log-link-entity type="ConfigurationKey" [id]="cell.data.ConfigurationKeysId"></app-change-log-link-entity>
                        <app-change-log-link-entity type="DisplayDataField" [id]="cell.data.DataField.DataFieldsId"></app-change-log-link-entity>
                    </app-change-log-link>
                </ng-container>

                <ng-container *dxTemplate="let cellInfo of 'editTemplate'">
                    <a class="dx-link" (click)="editConfigurationKey(cellInfo)"
                        *bizPermissionRequired="'Developer_Action_ConfigurationKey_Edit'">Edit</a>
                    <span>&nbsp;</span>
                </ng-container>

            </dx-data-grid>

        </div>
    </div>
</div>
